<script>
import { Line } from "vue-chartjs";
export default {
    name: 'LineChart',
    extends: Line,
    props: {
        chartData: {
            type: Object,
            default : null,
        },
        options: {
            type: Object,
            default : null
        },
        data: []
    },
    mounted() {
        this.renderLineChart();
    },

    methods : {
        renderLineChart () {
            this.renderChart(
                {
                    labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul","Aug","Sep","Oct","Nov","Dec"],
                    datasets: [
                        {
                            label: "Data",
                            borderColor: "#FFFFFF",
                            pointBorderColor: "#000000",
                            pointBackgroundColor: "#FFFFFF",
                            pointHoverBackgroundColor: "#000000",
                            pointHoverBorderColor: "#FFFFFF",
                            pointBorderWidth: 5,
                            pointHoverRadius: 5,
                            pointHoverBorderWidth: 5,
                            pointRadius: 5,
                            fill: false,
                            borderWidth: 3,
                            lineTension: 0,
                            data: this.data
                                //[20, 80, 180, 140, 180, 120, 100,150,90,70,40,30]
                        },
                    ],
                },
                this.options
            );
        }
    },
    watch: {
        chartData: function() {
            // this.renderLineChart();
        },
        data: function (v) {
            this.data = v;
            // console.log(v, 'watch data');
            this.renderLineChart();
        }
    }
};
</script>

<style>
</style>
